import { render } from "./Modules.vue?vue&type=template&id=1705a13a"
import script from "./Modules.vue?vue&type=script&lang=js"
export * from "./Modules.vue?vue&type=script&lang=js"

import "./Modules.vue?vue&type=style&index=0&id=1705a13a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__